import { render, staticRenderFns } from "./RealVideoSrs.vue?vue&type=template&id=4f3da8bd&scoped=true"
import script from "./RealVideoSrs.vue?vue&type=script&lang=js"
export * from "./RealVideoSrs.vue?vue&type=script&lang=js"
import style0 from "./RealVideoSrs.vue?vue&type=style&index=0&id=4f3da8bd&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3da8bd",
  null
  
)

export default component.exports